module.exports = __webpack_public_path__ + "media/site_templates/www.localfencingcompanies.com.au/images/splash-9d8eb253021e9b08f70084bb38ea2e6b.jpeg";